import { E_DATA_PROTECTION } from './route.types';
export const dataProtection = [
    {
        name: E_DATA_PROTECTION.DATA_PROTECTION,
        path: '/data-protection',
        redirect: {
            name: E_DATA_PROTECTION.EXPORT_MANAGEMENT,
        },
        component: () => import(/* webpackChunkName: "dataProtection" */ '../../views/data-protection/DataProtection/DataProtection.vue'),
        children: [
            {
                name: E_DATA_PROTECTION.EXPORT_MANAGEMENT,
                path: 'export-management',
                component: () => import(/* webpackChunkName: "dataProtection" */ '../../views/data-protection/ExportManagement/ExportManagement.vue'),
                props: true,
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.data_protection',
                        },
                        {
                            text: 'backoffice.nav.export_management',
                            active: true,
                        }
                    ],
                    permission: 'ExportManagement',
                },
            },
            {
                name: E_DATA_PROTECTION.RESTRICTION_LIST,
                path: 'restriction-list',
                component: () => import(/* webpackChunkName: "dataProtection" */ '../../views/data-protection/RestrictionList/RestrictionList.vue'),
                props: true,
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.data_protection',
                        },
                        {
                            text: 'backoffice.nav.restriction_list',
                            active: true,
                        }
                    ],
                    permission: 'RestrictionList',
                },
            },
            {
                name: E_DATA_PROTECTION.WHITELIST_MANAGEMEN,
                path: 'whitelist-management',
                component: () => import(/* webpackChunkName: "dataProtection" */ '../../views/data-protection/WhitelistManagement/WhitelistManagement.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.data_protection',
                        },
                        {
                            text: 'backoffice.nav.whitelist_management',
                            active: true,
                        }
                    ],
                    permission: 'WhiteList',
                },
            },
            {
                name: E_DATA_PROTECTION.USER_RESTRICTED_QUERY,
                path: 'user-restricted-query',
                component: () => import(/* webpackChunkName: "userRestrictedQuery" */ '../../views/data-protection/UserRestrictedQuery/UserRestrictedQuery.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.data_protection',
                        },
                        {
                            text: 'backoffice.nav.user_restricted_query',
                            active: true,
                        }
                    ],
                    permission: 'UserRestrictedQuery',
                },
            },
            {
                name: E_DATA_PROTECTION.COMPANY_TREE,
                path: 'company-tree',
                component: () => import(/* webpackChunkName: "dataProtection" */ '../../views/data-protection/CompanyTree/CompanyTree.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.data_protection',
                        },
                        {
                            text: 'backoffice.nav.company_tree',
                            active: true,
                        }
                    ],
                },
            },
            {
                name: E_DATA_PROTECTION.ILLEGAL_MANAGEMENT,
                path: 'illegal-management',
                redirect: {
                    name: E_DATA_PROTECTION.ILLEGAL_IP_MANAGEMENT,
                },
                component: () => import(/* webpackChunkName: "illegalManagement" */ '../../views/data-protection/IllegalManagement/IllegalManagement.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.data_protection',
                        },
                        {
                            text: 'backoffice.illegal.illegal_management',
                            active: true,
                        }
                    ],
                    permission: 'IllegalManagement',
                },
                children: [{
                        name: E_DATA_PROTECTION.ILLEGAL_IP_MANAGEMENT,
                        path: 'ip',
                        component: () => import(/* webpackChunkName: "IllegalIpManagement" */ '../../views/data-protection/IllegalManagement/IllegalIpManagement/IllegalIpManagement.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'backoffice.nav.data_protection',
                                },
                                {
                                    text: 'backoffice.illegal.illegal_management',
                                },
                                {
                                    text: 'backoffice.illegal.ip_management',
                                    active: true,
                                }
                            ],
                            permission: 'IllegalManagement',
                        },
                    },
                    {
                        name: E_DATA_PROTECTION.ILLEGAL_COMPANY_MANAGEMENT,
                        path: 'company',
                        component: () => import(/* webpackChunkName: "IllegalTenantManagement" */ '../../views/data-protection/IllegalManagement/IllegalTenantManagement/IllegalTenantManagement.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'backoffice.nav.data_protection',
                                },
                                {
                                    text: 'backoffice.illegal.illegal_management',
                                },
                                {
                                    text: 'backoffice.illegal.company_management',
                                    active: true,
                                }
                            ],
                            permission: 'IllegalManagement',
                        },
                    },
                    {
                        name: E_DATA_PROTECTION.ILLEGAL_ACCOUNT_MANAGEMENT,
                        path: 'account',
                        component: () => import(/* webpackChunkName: "IllegalAccountManagement" */ '../../views/data-protection/IllegalManagement/IllegalAccountManagement/IllegalAccountManagement.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'backoffice.nav.data_protection',
                                },
                                {
                                    text: 'backoffice.illegal.illegal_management',
                                },
                                {
                                    text: 'backoffice.illegal.account_management',
                                    active: true,
                                }
                            ],
                            permission: 'IllegalManagement',
                        },
                    }
                ],
            }
        ],
    }
];
/**
 * 限制规则 页面级子菜单
 * 注意这里的顺序需要和菜单顺序保持一致
 */
//  export const RuleManagementRoutePermissionTable = [
//     { name: E_DATA_PROTECTION.EXPORT_MANAGEMENT, permission: 'ExportManagement' },
//     { name: E_DATA_PROTECTION.RESTRICTION_LIST, permission: 'RestrictionList' },
//     { name: E_DATA_PROTECTION.WHITELIST_MANAGEMEN, permission: 'WhiteList' },
//     { name: E_DATA_PROTECTION.USER_RESTRICTED_QUERY, permission: 'UserRestrictedQuery' },
// ]
